export default __webpack_public_path__ + "static/media/solarpanel.7ce60edc.png";